import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
    spinner: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexGrow: 1,
    },
});
